import type Session from '@utils/Session'

export default class GatedFeatures {
  private readonly session: Session

  constructor(session: Session) {
    this.session = session
  }

  showAds(): boolean {
    return this.showGatedFeature('showAds', true)
  }

  canUseDarkMode(): boolean {
    return this.showGatedFeature('darkMode', false)
  }

  shouldShowArrangeMe(): boolean {
    return this.showGatedFeature('showArrangeMe', true)
  }

  forceArrangeMeSales(): boolean {
    return this.showGatedFeature('forceArrangeMeSales', true)
  }

  showEEI(): boolean {
    return this.showGatedFeature('showEei', false)
  }

  showPublicCollections(): boolean {
    return this.showGatedFeature('publicCollections', true)
  }

  allowLargeEnsembles(): boolean {
    return this.showGatedFeature('allowLargeEnsembles', true)
  }

  sortByRelevance(): boolean {
    return this.showGatedFeature('sortByRelevance', true)
  }

  useMeasureViewCache(): boolean {
    return this.showGatedFeature('useMeasureViewCache', true)
  }

  useSvgPreviews(): boolean {
    return this.showGatedFeature('useSvgPreviews', true)
  }

  /**
   * Helper function that takes a look at the client settings to determine whether or not to reveal the feature
   * that corresponds to the key. If `allowAnonymous` is true, then anonymous users will be allow in if the settings
   * value is ["*"]
   */
  showGatedFeature(key: string, allowAnonymous?: boolean): boolean {
    const setting = this.session.clientSettings[key]
    const isSplat = Array.isArray(setting) && setting.length && setting[0] === '*'
    if (this.session.isLoggedIn() && setting) {
      // If the user appears in the xxx-exclude list, deny them regardless of the other settings
      const excludedSetting = this.session.clientSettings[`${key}-exclude`]
      if (this.session.isDefaultCommunity() && excludedSetting) {
        for (const excludedUser of excludedSetting) {
          if (excludedUser === this.session.currentUser?.username) return false
        }
      }

      if (isSplat) return true

      // If default community and username is in client setting
      if (this.session.isDefaultCommunity()) {
        for (const includedUser of setting) {
          if (includedUser === this.session.currentUser?.username) return true
        }
      }
      // Not default community: "community-xxx"
      else {
        const communityKey = 'community-'
        for (const includedCommunity of setting) {
          const val = includedCommunity.toLowerCase()
          if (val.indexOf(communityKey) !== -1) {
            const communityName = val.substring(communityKey.length, val.length)
            if (this.session.community.name.toLowerCase() === communityName) return true
          }
        }
      }
    }
    // If anonymous users are allowed, then allow them if the setting is "*"
    else if (allowAnonymous && !this.session.isLoggedIn() && isSplat) {
      return true
    }
    return false
  }
}
